import { jsx as c } from "@emotion/react/jsx-runtime";
import { useMemo as i } from "react";
import { useTableContext as f } from "../../TableContext.js";
import { FlexDiv as u } from "./SelectBar.styled.js";
function I({
  children: l,
  data: e,
  idKey: t,
  className: n
}) {
  const {
    selectedRowIds: r,
    unselectAll: m
  } = f(), o = i(() => e.filter((s) => r[s[t]]), [e, t, r]);
  return o.length === 0 ? null : /* @__PURE__ */ c(u, { className: n, children: l({
    selectedItems: o,
    unselectAll: m
  }) });
}
export {
  I as SelectBar
};
